// File: src/components/Testimonials.jsx
import React from 'react';

// Sample data for the happy customers/testimonials
const customerFeedback = [
    {
        id: 1,
        quote: "Devulex transformed our outdated platform into a high-performance, modern application. The attention to detail and communication was outstanding!",
        name: "NanthaKumar T",
        title: "CEO, TamilManamalai Matrimony"
    },
    {
        id: 2,
        quote: "Scalable, robust, and delivered ahead of schedule. Their full-stack expertise is the reason our launch was a massive success.",
        name: "Arumugam P",
        title: "CEO, TamilManamalai Matrimony"
    },
    {
        id: 3,
        quote: "The team provided insightful solutions to complex scaling issues. Truly professional and highly skilled in modern web technologies.",
        name: "Sundar C",
        title: "CTO, Digital Agency"
    },
    {
        id: 4,
        quote: "Our website traffic and conversion rates doubled after the redesign. Highly recommend Devulex for any serious development work.",
        name: "Ajith",
        title: "Marketing Director, Retail Brand"
    },
    // --- EXTRA CUSTOMERS ADDED BELOW ---
    {
        id: 5,
        quote: "We needed a custom integration for our payment gateway, and Devulex handled the complexity flawlessly. Exceptional service and coding quality.",
        name: "Priya S",
        title: "Founder, E-commerce Platform"
    },
    {
        id: 6,
        quote: "From initial concept to final deployment, the process was smooth and collaborative. They are now our trusted long-term development partner.",
        name: "Vijay M",
        title: "Director of Product, FinTech"
    },
    // --- END OF EXTRA CUSTOMERS ---
];


const Testimonials = () => {
    return (
        <section id="testimonials" className="testimonials-section" style={{marginTop:'-80px'}}>
            <div className="testimonials-content">
                
                <h2 className="section-title" style={{ color: '#2ECC71',fontSize:'1.5rem',marginTop:'-40px' }}> Happy Customers</h2>
                <p className="section-subtitle">Real feedback from clients who trust our expertise.</p>

                <div className="testimonials-grid">
                    {customerFeedback.map(customer => (
                        <div className="testimonial-card" key={customer.id}>
                            <p className="testimonial-quote">
                                <span className="quote-mark">“</span>
                                {customer.quote}
                                <span className="quote-mark">”</span>
                            </p>
                            <div className="customer-details">
                                <h4 className="customer-name">{customer.name}</h4>
                                <p className="customer-title">{customer.title}</p> {/* Added customer.title here */}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;